import React from 'react';
import { IMessage } from '../../services/messaging/IMessagingProvider';
import { MessageMedia } from './MessageMedia';

interface MessageBubbleProps {
  message: IMessage;
  isOwn: boolean;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isOwn }) => {
  const formatTimestamp = (timestamp: number | string | Date) => {
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    if (isToday) {
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) +
        ' ' + date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isOwn ? 'flex-end' : 'flex-start',
        marginBottom: '8px'
      }}
    >
      <div
        style={{
          maxWidth: '70%',
          padding: '10px 14px',
          borderRadius: '18px',
          backgroundColor: isOwn ? 'var(--primary-color)' : 'var(--background-paper)',
          color: isOwn ? 'white' : 'var(--text-primary)',
          border: isOwn ? 'none' : '1px solid var(--border-color)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {message.content && (
          <div style={{ marginBottom: message.mediaUrl ? '8px' : '0' }}>
            {message.content}
          </div>
        )}

        {message.mediaUrl && (
          <MessageMedia
            mediaType={message.mediaType as 'image' | 'video' | 'link' | 'audio'}
            mediaUrl={message.mediaUrl}
            thumbnailUrl={message.thumbnailUrl}
            mediaKey={message.mediaKey}
            mediaMimeType={message.mediaMimeType}
          />
        )}

        <div
          style={{
            fontSize: '11px',
            marginTop: '4px',
            opacity: 0.7,
            textAlign: 'right',
            color: isOwn ? 'rgba(255, 255, 255, 0.8)' : 'var(--text-secondary)'
          }}
        >
          {formatTimestamp(message.timestamp)}
          {isOwn && (
            <span style={{ marginLeft: '4px', verticalAlign: 'middle' }} title={message.status === 'read' ? 'Seen' : 'Sent'}>
              <span
                className="material-icons"
                style={{
                  fontSize: '14px',
                  verticalAlign: 'middle',
                  color: message.status === 'read'
                    ? '#4fc3f7'
                    : 'rgba(255,255,255,0.5)'
                }}
              >
                {message.status === 'read' ? 'done_all' : 'done'}
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
